// import React from "react";

// class BookingView extends React.Component {
//     render() {
//         return (
//             <div>
//                 test aghdas
//             </div>
//         )
//     }
// }


// export default BookingView;


import React, { Component } from 'react'
// import HttpServices from '../../utils/Http.services'
// import { translate } from '../../utils/useful'
import FirstStep from '../../components/BookingView/FirstStep'
import SecondStep from '../../components/BookingView/SecondStep'
import ThirdStep from '../../components/BookingView//ThirdStep'
import StagesManager from '../../components/StagesManager'
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
// import * as actions from '../../stores/actionsList';
// import { withRouter } from 'next/router'


class BookingView extends Component {
    state = {
        stage: 0,
        newData: {}
    }

    // componentDidMount() {
    //     // this.stageManager.changeStage("secondStep")
    // }

    addDone = () => {
        this.setState({ stage: 1 })
    }

    setData = (data, cb) => {
        let newData = this.state.data
        if (!newData) {
            newData = {}
        }
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }

    changePage = (key, stage) => {
        // window.scrollTo({ top: 0, behavior: 'smooth' })
        this.stageManager.changeStage(key)
        this.setState({ stage })
    }


    // postInformation = (cb) => {
    //     let data = this.state.data
    //     data.owner = this.props.user?.current?._id
    //     // console.log('formmmmm', data)
    //     if (data) {
    //         // console.log("practice", data)

    //         HttpServices.request('addProduct', data, (fetchResult, fetchError) => {

    //             if (fetchError) {
    //                 cb(null,fetchError)
    //                 return console.log("fetchError", fetchError);
    //             }
    //             // if (fetchResult) {
    //                 cb(fetchResult)

    //                 console.log("successfuly", fetchResult);
    //             // }
    //         })
    //     }
    // }


    clearData = () => {
        this.setState({ data: {} })
    }


    render() {
        return (
            <div className='h-100 scroll-no-scrollbar pb-5 window-content-radius' style={{ padding: '0 20px' }}>
                {/* {console.log('information formmmmmmm', this.state?.data)} */}
                {/* {console.log('staageeee', this.state.stage)} */}
                <p className="text-big font-bold mb-3 mt-3">Booking View</p>

                <div style={{ justifyContent: 'space-between', alignItems: 'center' }} className='mb-4 d-flex'>
                    <div onClick={() => this.changePage("firststep", 0)} className='d-flex' style={{ width: '35px', height: '35px', borderRadius: '50%' }}>
                        <img src="/images/firststep.svg" alt="" />
                    </div>
                    <div style={{ position: 'relative', width: '100%', borderBottom: "2px solid #eee", borderRadius: "5px", }}>
                        <div className='pos-abs transition-all' style={{ width: this.state.stage > 0 ? '100%' : '30%', borderBottom: '6px solid #ff3543', borderRadius: '10px' }}></div>
                    </div>
                    <div onClick={() => { if (this.state.stage > 1) { this.changePage("secondStep", 1) } }} className='d-flex' style={{ width: '35px', height: '35px', borderRadius: '50%' }}>
                        <img src="/images/secondstep.svg" alt="" />
                    </div>
                    <div style={{ position: 'relative', width: '100%', borderBottom: "2px solid #eee", borderRadius: "5px", }}>
                        <div className='pos-abs transition-all' style={{ width: this.state.stage > 1 ? '100%' : '0', borderBottom: '6px solid #ff3543', borderRadius: '10px' }}></div>
                    </div>
                    <div className='d-flex' style={{ width: '35px', height: '35px', borderRadius: '50%' }}>
                        <img src="/images/thirdstep.svg" alt="" />
                    </div>
                </div>


                <StagesManager ref={el => this.stageManager = el} >

                    <FirstStep stage={0} stageName={'firststep'} initData={this.state.data} addAction={this.addAction} changePage={this.changePage} setData={this.setData} />
                    <SecondStep stage={1} stageName={'secondStep'} initData={this.state.data} addAction={this.addAction} changePage={this.changePage} setData={this.setData} />
                    <ThirdStep stage={2} stageName={'thirdstep'} initData={this.state.data} addAction={this.addAction} changePage={this.changePage} setData={this.setData} clearData={this.clearData} postInformation={this.postInformation} />

                </StagesManager>
            </div>
        )
    }
}




export default BookingView;

